module.exports = __webpack_public_path__ + "img/news.9cbf7279.png";